import {
  Button,
  CloseIcon,
  DatePicker,
  Drawer,
  Radio,
  Select,
  Text,
} from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import {
  ShipmentInvoicePaymentPriorityEnum,
  ShipmentInvoiceStatusEnum,
} from '@/types'
import { DrawerFilterProps } from './drawer-filter.type'

import styles from './drawer-filter.module.css'

export const ShipmentInvoiceDrawerFilter = ({
  isOpen,
  onHandleOpen,
  filter,
  onHandleFilter,
  transportCompanies,
}: DrawerFilterProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('screenSupplierOrderManagementPage')

  const onChangeBooleanOfSingleValue = (key: string, value: string) => {
    onHandleFilter({ ...filter, [key]: value })
  }

  const getBooleanOfSingleValue = (key: string, value: string): boolean => {
    return filter[key] === value
  }

  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <div className={styles.header}>
        <Text variant="title-large" className={styles['header-title']}>
          {t('drawerFilterTitle')}
        </Text>

        <button
          className={styles['header-button']}
          type="button"
          onClick={onHandleOpen}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.content}>
        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('tableShipmentInvoiceDrawerFilterTransportCompany')}
          </Text>
          <Select
            value={filter.transportCompany_Email || ''}
            options={[
              {
                label: t('tableShipmentInvoiceDrawerFilterNoFilled'),
                value: '',
              },
              ...(transportCompanies?.map((transportCompany) => ({
                label: transportCompany?.name,
                value: `${transportCompany?.email}`,
              })) || []),
            ]}
            onChange={(newValue) =>
              onHandleFilter({ ...filter, transportCompany_Email: newValue })
            }
            placeholder={t(
              'tableShipmentInvoiceDrawerFilterTransportCompanyPlaceholder',
            )}
          />
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('tableShipmentInvoiceDrawerFilterPaymentPriority')}
          </Text>
          <Select
            value={filter?.paymentPriority || ''}
            allowEmpty={false}
            options={[
              {
                label: t('tableShipmentInvoiceDrawerFilterNoFilled'),
                value: '',
              },
              ...Object.keys(ShipmentInvoicePaymentPriorityEnum).map((key) => ({
                label: tEnums(`shipment_invoice_payment_priority_${key}`),
                value: key,
              })),
            ]}
            onChange={(newValue) =>
              onHandleFilter({
                ...filter,
                paymentPriority: newValue || '',
              })
            }
            placeholder={t(
              'tableShipmentInvoiceDrawerFilterPaymentPriorityPlaceholder',
            )}
          />
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('tableShipmentInvoiceDrawerFilterExpectedPaid')}
          </Text>
          <div className={styles['content-filter-date']}>
            <DatePicker
              value={filter.expectedPaymentDateAfter || ''}
              onChange={(newValue) =>
                onHandleFilter({
                  ...filter,
                  expectedPaymentDateAfter: newValue || '',
                })
              }
              placeholder={t(
                'tableShipmentInvoiceDrawerFilterExpectedPaidStartPlaceholder',
              )}
            />
            <Text>-</Text>
            <DatePicker
              value={filter.expectedPaymentDateBefore || ''}
              onChange={(newValue) =>
                onHandleFilter({
                  ...filter,
                  expectedPaymentDateBefore: newValue || '',
                })
              }
              placeholder={t(
                'tableShipmentInvoiceDrawerFilterExpectedPaidEndPlaceholder',
              )}
            />
          </div>
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('tableShipmentInvoiceDrawerFilterStatus')}
          </Text>
          <div className={styles.grid}>
            {Object.keys(ShipmentInvoiceStatusEnum).map((key) => (
              <Radio
                key={key}
                value={getBooleanOfSingleValue('status', key)}
                onChange={() => onChangeBooleanOfSingleValue('status', key)}
              >
                {tEnums(`shipment_invoice_status_${key}`)}
              </Radio>
            ))}
          </div>
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('tableShipmentInvoiceDrawerFilterCurrency')}
          </Text>
          <div className={styles['content-filter-row']}>
            <Radio
              value={getBooleanOfSingleValue('currency', '')}
              onChange={() => onChangeBooleanOfSingleValue('currency', '')}
            >
              {t('tableShipmentInvoiceDrawerFilterCurrencyAll')}
            </Radio>
            <Radio
              value={getBooleanOfSingleValue('currency', 'MXN')}
              onChange={() => onChangeBooleanOfSingleValue('currency', 'MXN')}
            >
              MXN
            </Radio>
            <Radio
              value={getBooleanOfSingleValue('currency', 'USD')}
              onChange={() => onChangeBooleanOfSingleValue('currency', 'USD')}
            >
              USD
            </Radio>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onHandleOpen}>
          {t('drawerFilterButtonBack')}
        </Button>
      </div>
    </Drawer>
  )
}
